import { 
    Box,
    Typography
  } from '@mui/material';
  import { AreaChart, Area, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';
  import { AdcashAvatyeDetailDailyRevenue } from '../../../../types/adcash.types';
  
  type Props = {
    dailyRevenue: AdcashAvatyeDetailDailyRevenue[];
    exchangeRate: number;
  }
  
  export default function AdcashAvatyeDetailDashboard(
    {
      dailyRevenue,
      exchangeRate
    }: Props
  ) {
    const formatCurrency = (value: number) =>
      new Intl.NumberFormat('ko-KR', {
        style: 'currency',
        currency: 'KRW',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
    
    const chartData = dailyRevenue.map(stat => ({
      date: stat.date,
      revenue: stat.revenue * exchangeRate
    }));

    return (
      <Box sx={{ display: 'flex', gap: 3, mt: 3, minWidth: 0 }}>
        <Box
          sx={{
            border: '1px solid #e0e0e0',
            backgroundColor: '#ffffff',
            borderRadius: 2,
            p: 3,
            flex: 1,
            minHeight: 100,
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, textAlign: 'center' }}>
            일별 매출 추이
          </Typography>
          <ResponsiveContainer width="100%" height={200}>
            <AreaChart data={chartData}>
              <defs>
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#0044D2" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#0044D2" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis 
                dataKey="date"
                tickFormatter={(value: string) => {
                  const date = new Date(value);
                  return `${date.getMonth() + 1}/${date.getDate()}`;
                }}
              />
              <YAxis 
                tickFormatter={(value: number) => {
                  if (value === 0) return '0';
                  return `${(value / 1000).toFixed(0)}K`;
                }} 
              />
              <RechartsTooltip
                formatter={(value: number) => formatCurrency(value)}
                labelFormatter={(value: string) =>
                  new Date(value).toLocaleDateString('ko-KR')
                }
              />
              <Area
                type="monotone"
                dataKey="revenue"
                stroke="#0044D2"
                strokeWidth={2}
                fillOpacity={1}
                fill="url(#colorRevenue)"
                name="매출"
              />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    );
  }
  